import { render, staticRenderFns } from "./Old.vue?vue&type=template&id=0c272854"
import script from "./Old.vue?vue&type=script&lang=js"
export * from "./Old.vue?vue&type=script&lang=js"
import style0 from "./Old.vue?vue&type=style&index=0&id=0c272854&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports